import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getPaymentDetails } from "../../../services/doctors";
import { useToast } from "../../../components/ui/use-toast";
import { useAuth } from "../../../contexts/auth-context";

type UsePaymentDetailsByIdOptions = {
  enabled?: boolean;
};

export function usePaymentDetailsById(
  apptId?: number,
  options?: UsePaymentDetailsByIdOptions
) {
  const { toast } = useToast();
  const { mobile } = useAuth();

  const {
    data: paymentDetails,
    isPending,
    isError,
    isFetched,
  } = useQuery({
    queryKey: ["payment-details-by-id", apptId],
    queryFn: () => getPaymentDetails(apptId),
    enabled: !!mobile && !!apptId && (options?.enabled ?? true),
    retry: 0,
  });

  useEffect(() => {
    if (isError && apptId) {
      toast({
        title: "Failed to fetch payment details",
        variant: "destructive",
      });
    }
  }, [isError, toast, apptId]);

  return { paymentDetails, isPending, isFetched };
}
